export function setCircleSwatchWidth(selector) {
    // 检查是否匹配移动设备媒体查询
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const colorsWrapper = document.querySelector(`${selector} .product-card__colors-wrapper`);
    if (colorsWrapper) {
        const colorsWrapperWidth = colorsWrapper.getBoundingClientRect().width;
        let circleSwatchWidth;
        if (isMobile) {
            circleSwatchWidth = (colorsWrapperWidth - 11 * 5) / 5.5;
        } else {
            circleSwatchWidth = (colorsWrapperWidth - 40 - 12 * 6) / 6;
        }
        let parentContainer = colorsWrapper.closest(selector);
        if (parentContainer) {
            parentContainer.style.setProperty('--pgw-circle-swatch-width', ( circleSwatchWidth/ 10) + 'rem');
        }        
    }
    
}

document.addEventListener('DOMContentLoaded', function () {
    setCircleSwatchWidth(".shop__products");

    function debounce(func, wait) {
        let timeout;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
            func.apply(context, args);
            }, wait);
        };
    }

    const debouncedSetCircleSwatchWidth = debounce(setCircleSwatchWidth, 250);

    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            const width = entry.contentRect.width;
            // 执行你的函数
            debouncedSetCircleSwatchWidth(".shop__products");
        }
    });

    // 观察整个文档
    resizeObserver.observe(document.documentElement);

    // 监听一行显示几个的switch的点击事件
    const columnSwitchers =  document.querySelectorAll(".column-switcher");
    columnSwitchers.forEach(function(columnSwitcher) {
        columnSwitcher.addEventListener("click", function() {
            debouncedSetCircleSwatchWidth(".shop__products");
        });
    });

    // 或者观察特定元素
    // resizeObserver.observe(document.querySelector('.product-card__images-wrapper'));
});